import { Product } from "tm-shared/types";

export enum CatalogKey {
    Products = "products",
}

export interface CatalogData {
    [CatalogKey.Products]: Record<string, Product>;
}

export type CatalogMeta = Record<CatalogKey, { version: string }>;

export interface CatalogStorage {
    write<K extends CatalogKey>(key: K, data: CatalogData[K]): Promise<void>;
    read<K extends CatalogKey>(key: K): Promise<CatalogData[K] | null>;
    delete(key: CatalogKey): Promise<void>;
    saveMeta(key: CatalogKey, version: string): Promise<void>;
    getMeta(): Promise<CatalogMeta | null>;
    getVersion(key: CatalogKey): Promise<string | null>;

    close?(): Promise<void>;
}
